import React from 'react';

const DatenschutzPage = () => {
  return (
    <div className="min-h-screen pt-24 pb-16" data-testid="datenschutz-page">
      <section className="section-padding bg-surface">
        <div className="container-max">
          <h1 className="text-4xl md:text-5xl font-heading font-bold uppercase tracking-tighter mb-4">
            <span className="text-primary">Datenschutz</span>erklärung
          </h1>
        </div>
      </section>

      <section className="section-padding">
        <div className="container-max">
          <div className="max-w-3xl space-y-8">
            <div>
              <h2 className="text-xl font-heading font-bold uppercase mb-4">1. Verantwortlicher</h2>
              <p className="text-text-secondary text-sm">
                House of Darts<br />
                Marktplatz 11, 5204 Straßwalchen, Österreich<br />
                E-Mail: house.of.darts.strasswalchen@gmail.com<br />
                Telefon: 0677 63139171<br />
                Obmann: Subhan Klicic
              </p>
            </div>

            <div>
              <h2 className="text-xl font-heading font-bold uppercase mb-4">2. Erhebung und Verarbeitung personenbezogener Daten</h2>
              <p className="text-text-secondary text-sm mb-3">
                Wir verarbeiten personenbezogene Daten gemäß der Datenschutz-Grundverordnung (DSGVO) und dem österreichischen Datenschutzgesetz (DSG). Folgende Daten werden bei der Registrierung und Nutzung unserer Website erhoben:
              </p>
              <ul className="list-disc list-inside text-text-secondary text-sm space-y-1 ml-4">
                <li>Vor- und Nachname</li>
                <li>E-Mail-Adresse</li>
                <li>Telefonnummer (optional)</li>
                <li>Adresse (optional)</li>
                <li>Geburtsdatum (optional)</li>
                <li>Mitgliedsnummer (automatisch vergeben)</li>
                <li>Zahlungsdaten (über Stripe/PayPal verarbeitet)</li>
              </ul>
            </div>

            <div>
              <h2 className="text-xl font-heading font-bold uppercase mb-4">3. Zweck der Datenverarbeitung</h2>
              <p className="text-text-secondary text-sm mb-3">
                Die erhobenen Daten werden ausschließlich für folgende Zwecke verwendet:
              </p>
              <ul className="list-disc list-inside text-text-secondary text-sm space-y-1 ml-4">
                <li>Mitgliederverwaltung und Vereinsorganisation</li>
                <li>Turnierorganisation und Ranglistenführung</li>
                <li>Abwicklung von Mitgliedsbeiträgen und Zahlungen</li>
                <li>Kommunikation mit Vereinsmitgliedern</li>
                <li>Trainingsbuchung und -organisation</li>
              </ul>
            </div>

            <div>
              <h2 className="text-xl font-heading font-bold uppercase mb-4">4. Rechtsgrundlage</h2>
              <p className="text-text-secondary text-sm">
                Die Verarbeitung erfolgt auf Grundlage von Art. 6 Abs. 1 lit. a DSGVO (Einwilligung), Art. 6 Abs. 1 lit. b DSGVO (Vertragserfüllung) sowie Art. 6 Abs. 1 lit. f DSGVO (berechtigte Interessen des Vereins).
              </p>
            </div>

            <div>
              <h2 className="text-xl font-heading font-bold uppercase mb-4">5. Zahlungsanbieter</h2>

              <h3 className="font-bold mt-4 mb-2">Stripe</h3>
              <p className="text-text-secondary text-sm">
                Für die Zahlungsabwicklung nutzen wir den Dienst Stripe Payments Europe, Ltd., 1 Grand Canal Street Lower, Grand Canal Dock, Dublin, Irland. Bei Kartenzahlungen und Apple Pay werden Ihre Zahlungsdaten direkt an Stripe übermittelt und dort verarbeitet. Stripe ist PCI DSS Level 1 zertifiziert. Weitere Informationen finden Sie in der <a href="https://stripe.com/de/privacy" target="_blank" rel="noopener noreferrer" className="text-accent hover:underline">Datenschutzerklärung von Stripe</a>.
              </p>

              <h3 className="font-bold mt-4 mb-2">PayPal</h3>
              <p className="text-text-secondary text-sm">
                Für Einmalzahlungen und Spenden bieten wir PayPal an. Betreiber ist PayPal (Europe) S.à r.l. et Cie, S.C.A., 22-24 Boulevard Royal, L-2449 Luxembourg. Bei Zahlung über PayPal werden Ihre Zahlungsdaten an PayPal übermittelt. Weitere Informationen in der <a href="https://www.paypal.com/de/webapps/mpp/ua/privacy-full" target="_blank" rel="noopener noreferrer" className="text-accent hover:underline">Datenschutzerklärung von PayPal</a>.
              </p>
            </div>

            <div>
              <h2 className="text-xl font-heading font-bold uppercase mb-4">6. Server-Logfiles</h2>
              <p className="text-text-secondary text-sm">
                Bei jedem Zugriff auf unsere Website werden automatisch Daten in Server-Logfiles gespeichert. Diese beinhalten: Browsertyp und -version, verwendetes Betriebssystem, Referrer-URL, IP-Adresse des zugreifenden Rechners, Uhrzeit der Serveranfrage. Diese Daten sind nicht bestimmten Personen zuordenbar und werden nicht mit anderen Datenquellen zusammengeführt.
              </p>
            </div>

            <div>
              <h2 className="text-xl font-heading font-bold uppercase mb-4">7. Cookies</h2>
              <p className="text-text-secondary text-sm">
                Unsere Website verwendet Cookies. Dabei handelt es sich um technisch notwendige Cookies für die Authentifizierung (Login) und Sitzungsverwaltung. Diese Cookies werden benötigt, damit Sie sich anmelden und die Website nutzen können. Eine Nutzung der Website ohne diese Cookies ist eingeschränkt möglich.
              </p>
            </div>

            <div>
              <h2 className="text-xl font-heading font-bold uppercase mb-4">8. Ihre Rechte</h2>
              <p className="text-text-secondary text-sm mb-3">
                Sie haben gemäß DSGVO folgende Rechte bezüglich Ihrer personenbezogenen Daten:
              </p>
              <ul className="list-disc list-inside text-text-secondary text-sm space-y-1 ml-4">
                <li><strong>Auskunftsrecht</strong> (Art. 15 DSGVO): Sie haben das Recht, Auskunft über Ihre bei uns gespeicherten Daten zu erhalten.</li>
                <li><strong>Berichtigungsrecht</strong> (Art. 16 DSGVO): Sie können die Berichtigung unrichtiger Daten verlangen.</li>
                <li><strong>Löschungsrecht</strong> (Art. 17 DSGVO): Sie können die Löschung Ihrer Daten verlangen, sofern keine gesetzliche Aufbewahrungspflicht besteht.</li>
                <li><strong>Widerspruchsrecht</strong> (Art. 21 DSGVO): Sie können der Verarbeitung Ihrer Daten jederzeit widersprechen.</li>
                <li><strong>Beschwerderecht</strong>: Sie haben das Recht, sich bei der österreichischen Datenschutzbehörde (dsb.gv.at) zu beschweren.</li>
              </ul>
            </div>

            <div>
              <h2 className="text-xl font-heading font-bold uppercase mb-4">9. Kontakt Datenschutz</h2>
              <p className="text-text-secondary text-sm">
                Bei Fragen zum Datenschutz erreichen Sie uns unter:<br />
                <a href="mailto:house.of.darts.strasswalchen@gmail.com" className="text-accent hover:underline">
                  house.of.darts.strasswalchen@gmail.com
                </a>
              </p>
            </div>

            <div>
              <h2 className="text-xl font-heading font-bold uppercase mb-4">10. Änderungen</h2>
              <p className="text-text-secondary text-sm">
                Wir behalten uns vor, diese Datenschutzerklärung bei Bedarf anzupassen. Die aktuelle Version ist stets auf dieser Seite verfügbar.
              </p>
              <p className="text-text-secondary text-sm mt-2">
                Stand: April 2026
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default DatenschutzPage;
